import classNames from "classnames";
import * as React from "react";
import { FC } from "react";
import "./Checkbox.scss";

export interface ICheckbox {
    label?: string;
    subTitle?: string;
    required?: boolean;
    checked?: boolean;
    defaultChecked?: boolean;
    onChange: (checked: boolean) => void;
}
/* use 'checked' only for 'controlled' component, when state is managed by it`s parent  */
/* use 'defaultChecked' only for 'uncontrolled' component, when state is not managed by parent */
/* https://github.com/facebook/react/issues/13477#issuecomment-416003818 */
export const Checkbox: FC<ICheckbox> = (props) => (
    <div className={classNames("checkmark-element", { required: props.required })}>
        <label className="checkmark-container">
            {props.label || ""}
            {typeof props.checked === "boolean" ? (
                <input /* controlled input */
                    type="checkbox"
                    checked={props.checked}
                    onChange={(e) => props.onChange(e.target.checked)}
                />
            ) : (
                <input /* uncontrolled input */
                    type="checkbox"
                    defaultChecked={props.defaultChecked}
                    //@ts-ignore
                    onClick={(e) => props.onChange(e.target.checked)}
                />
            )}
            <span className="checkmark"></span>
        </label>
        {props.subTitle ? <div className="checkmark-subtitle">{props.subTitle}</div> : null}
    </div>
);
